// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ScopeChangeRequestDetailsPanel__root___L2EVH"};